import React from "react";

import TestResultComponent from "./test_result";
import {LlmRunId} from "common/flowmaster/types/llm_run";
import {BasicTestResultForLlmRun} from "common/flowmaster/types/test";
import {OrganisationId} from "common/types/organisation";

type Props = {
  results: BasicTestResultForLlmRun[];
  llmRunId: LlmRunId;
  organisationId: OrganisationId;
  showResults?: () => void;
};

export default function TestResults({
  results,
  llmRunId,
  organisationId,
  showResults,
}: Props) {
  const thisRunResult = results.find(result => result.llm_run_id === llmRunId);
  return (
    <div style={{display: "flex", justifyContent: "space-around"}}>
      <span
        style={{
          display: "inline-flex",
          border: "1px solid #888",
          borderRadius: "0.5em",
          margin: "1px",
        }}
      >
        {thisRunResult && (
          <span style={{borderRight: "1px solid #888"}}>
            <TestResultComponent result={thisRunResult} onClick={showResults} />
          </span>
        )}
        <span style={{backgroundColor: "#ccc"}}>
          {results
            .filter(result => result.llm_run_id !== llmRunId)
            .slice(0, 5)
            .map((result, i) => (
              <TestResultComponent
                key={i}
                result={result}
                link={`/organisation/${organisationId}/llm_run/${result.llm_run_id}/detail`}
              />
            ))}
        </span>
      </span>
    </div>
  );
}
